import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import i18n from "../utils/i18n";

//modules
import user from "./modules/user.js"
import job from "./modules/job.js"
export default new Vuex.Store({
  state: {
    lang: true,
    words: i18n
  },
  getters: {
    words: state => {
      return state.lang ? i18n.CN : i18n.EN
    },
    lang: state => {
      return state.lang
    },
  },
  mutations: {
    setLangCommit(state, payload) {
      state.lang = payload
    }
  },
  actions: {
    SetLang({
      commit
    }, payload) {
      localStorage.setItem('lang', payload)
      console.log('payload',payload)
      commit("setLangCommit", payload)
    },
  },
  modules: {
    user,
    job
  }
});
